import { useState, useEffect } from 'react';

interface Settings {
  id: string;
  wahaHost: string;
  wahaApiKey: string;
  evolutionHost?: string;
  evolutionApiKey?: string;
  quepasaUrl?: string;
  quepasaLogin?: string;
  quepasaPassword?: string;
  gozapHost?: string;
  gozapAdminToken?: string;
  logoUrl?: string;
  companyName?: string;
  faviconUrl?: string;
  pageTitle?: string;
  iconUrl?: string;
  criadoEm: string;
  atualizadoEm: string;
  // Tenant-scoped settings exposed via backend combined settings
  openaiApiKey?: string | null;
  groqApiKey?: string | null;
  chatwootUrl?: string | null;
  chatwootAccountId?: string | null;
  chatwootApiToken?: string | null;
  // New: provider lock per tenant
  whatsappProviderLock?: 'WAHA' | 'EVOLUTION' | 'QUEPASA' | 'GOZAP' | null;
}

// Cache global das configurações (compartilhado entre todas as instâncias do hook)
let cachedSettings: Settings | null = null;
let cachedError: string | null = null;
let loadingPromise: Promise<void> | null = null;

export function useSettings() {
  const [settings, setSettings] = useState<Settings | null>(cachedSettings);
  const [error, setError] = useState<string | null>(cachedError);
  const [loading, setLoading] = useState<boolean>(!cachedSettings && !cachedError);

  useEffect(() => {
    if (!loadingPromise) {
      const token = localStorage.getItem('auth_token');
      const headers: HeadersInit = {
        'Content-Type': 'application/json',
      };
      if (token) {
        (headers as Record<string, string>).Authorization = `Bearer ${token}`;
      }

      loadingPromise = fetch('/api/settings', { headers })
        .then(async (res) => {
          if (!res.ok) {
            throw new Error(`Erro ao carregar configurações: ${res.status}`);
          }
          return res.json();
        })
        .then((data: Settings) => {
          cachedSettings = data;
          cachedError = null;
          setSettings(data);
          setError(null);
        })
        .catch((err: any) => {
          const message = err instanceof Error ? err.message : 'Erro desconhecido';
          cachedError = message;
          setError(message);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      // If a load is already in progress, wait for it and then update
      loadingPromise
        .then(() => {
          setSettings(cachedSettings);
          setError(cachedError);
        })
        .finally(() => setLoading(false));
    }
  }, []);

  return { settings, error, loading };
}